// Should correspond to subjects defined in newsela/people/models/educator.py

export const ENGLISH_LANUAGE_ARTS = 'English/Language Arts/Reading';

export const ENGLISH_LANGUAGE_LEARNERS = 'English Language Learners';

export const FOREIGN_LANGUAGE = 'Foreign Language';

export const GENERAL_ELEMENTARY = 'General Elementary';

export const MATH = 'Math';

export const SCIENCE = 'Science';

export const SOCIAL_STUDIES = 'Social Studies/Social Science';

export const SPECIAL_EDUCATION = 'Special Education';

export const OTHER = 'Other';

export default [
  ENGLISH_LANUAGE_ARTS,
  ENGLISH_LANGUAGE_LEARNERS,
  FOREIGN_LANGUAGE,
  GENERAL_ELEMENTARY,
  MATH,
  SCIENCE,
  SOCIAL_STUDIES,
  SPECIAL_EDUCATION,
  OTHER,
];
